import { render, staticRenderFns } from "./credit-additional-report-table.vue?vue&type=template&id=844b960e"
import script from "./credit-additional-report-table.vue?vue&type=script&lang=ts"
export * from "./credit-additional-report-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports